import React, { Children } from 'react';
import { AnimatedSection, AnimatedItem } from './AnimatedSection';
import { XIcon } from 'lucide-react';
export function FailedMethodsSection() {
  return <AnimatedSection staggerChildren className="py-16 md:py-24 px-6 max-w-3xl mx-auto bg-cream rounded-3xl my-8" data-id="element-71">
      <div className="text-center mb-12" data-id="element-72">
        <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-4" data-id="element-73">
          Por Qué Lo Que Intentaste No Funcionó
        </h2>
      </div>

      <div className="space-y-6 mb-10" data-id="element-74">
        <AnimatedItem data-id="element-75">
          <div className="flex items-start gap-4 bg-white/60 rounded-xl p-6" data-id="element-76">
            <div className="mt-1 flex-shrink-0" data-id="element-77">
              <XIcon className="w-6 h-6 text-terracotta" data-id="element-78" />
            </div>
            <p className="text-charcoal/90 text-lg leading-relaxed" data-id="element-79">
              <span className="font-semibold text-charcoal" data-id="element-80">
                La meditación tradicional
              </span>{' '}
              es imposible de hacer cuando tu corazón late a 120 pulsaciones por
              minuto.
            </p>
          </div>
        </AnimatedItem>

        <AnimatedItem data-id="element-81">
          <div className="flex items-start gap-4 bg-white/60 rounded-xl p-6" data-id="element-82">
            <div className="mt-1 flex-shrink-0" data-id="element-83">
              <XIcon className="w-6 h-6 text-terracotta" data-id="element-84" />
            </div>
            <p className="text-charcoal/90 text-lg leading-relaxed" data-id="element-85">
              <span className="font-semibold text-charcoal" data-id="element-86">
                Intentar "pensar en positivo"
              </span>{' '}
              falla porque tu biología siempre le ganará a tu psicología en
              momentos de supervivencia.
            </p>
          </div>
        </AnimatedItem>

        <AnimatedItem data-id="element-87">
          <div className="flex items-start gap-4 bg-white/60 rounded-xl p-6" data-id="element-88">
            <div className="mt-1 flex-shrink-0" data-id="element-89">
              <XIcon className="w-6 h-6 text-terracotta" data-id="element-90" />
            </div>
            <p className="text-charcoal/90 text-lg leading-relaxed" data-id="element-91">
              <span className="font-semibold text-charcoal" data-id="element-92">
                Esperar a que pase
              </span>{' '}
              solo entrena a tu cerebro a volverse un "experto" en sentir miedo
              cada vez más seguido.
            </p>
          </div>
        </AnimatedItem>
      </div>
    </AnimatedSection>;
}